import React from 'react';
import { PropTypes } from 'prop-types';

const GalleryTabs = (props) => {
    function scrollToTarget(e) {
        const target = e.target.getAttribute("data-target");

        if (target && target.length > 0) {
            e.preventDefault();
            const offset = Number(e.target.getAttribute("data-target-offset"));
            $('html, body').animate({
                scrollTop: $(target).offset().top - offset
            }, 250);
        }
    }
    return (
        <nav className="container gallery-tabs sticky-top">
            <div className="nav navbar-light">
                {props.sections.map((section, i) => {
                    return (
                        section.artworks.length > 0 && <a className="nav-link"
                            key={i}
                            href={"#" + section.id}
                            data-target={"#" + section.id}
                            data-target-offset="40"
                            onClick={scrollToTarget}
                        >{section.name}</a>
                    );
                })}
                <a className="ml-auto nav-link top-link" onClick={scrollToTarget} data-target="body" href="#">
                    <i className="fa fa-arrow-circle-o-up" data-target="body" />
                </a>
            </div>
        </nav >
    );
};

GalleryTabs.propTypes = {
    sections: PropTypes.array.isRequired
};

export default GalleryTabs;



// WEBPACK FOOTER //
// ./src/components/gallery/GalleryTabs.js